import React, {useState} from 'react';
import Box from './Box';
import cn from 'clsx';
import styles from './NpsInput.module.scss';

export const NpsInput = ({
    name,
    value,
    onChange,
    textMin = '',
    textMax = '',
}) => {
    const [tmpChecked, setTmpChecked] = useState(null);
    const finalValue = tmpChecked !== null ? tmpChecked : value;

    return (
        <Box className={styles["nps-input"]}>
            <Box className={styles["nps-input__legend"]}>
                <span>{textMin}</span>
                <span>{textMax}</span>
            </Box>
            <Box className={styles["nps-input__list"]}>
                {
                    Array(10).fill(0).map((_, index) => {
                        const currentValue = index + 1;

                        return <RadioButton
                            onChange={onChange}
                            onMouseEnter={() => {
                                setTmpChecked(currentValue)
                            }}
                            onMouseLeave={() => {
                                setTmpChecked(null)
                            }}
                            key={`${name}_${currentValue}`}
                            id={`${name}_${currentValue}`}
                            active={finalValue > currentValue}
                            checked={finalValue === currentValue}
                            name={name}
                            value={currentValue}
                            label={currentValue}
                        />
                    })

                }
            </Box>
        </Box>
    )
}


const RadioButton = ({id, checked, name, active, value, label, onChange, onMouseEnter, onMouseLeave}) => {
    const handleChange = (e) => {
        if (typeof onChange === 'function') {
            onChange({
                name: name,
                value: value,
                checked: true
            });
        }
    }
    return (
        <label className={cn(styles['nps-input__radio'], {
            [styles['nps-input__radio--active']]: active,
            [styles['nps-input__radio--checked']]: checked,
        })}
               onClick={handleChange}
               onMouseEnter={onMouseEnter}
               onMouseLeave={onMouseLeave}
        >
            <input className={styles["nps-input__radio-input"]} type="radio" id={id} checked={checked} name={name} value={value} onChange={handleChange} />
            <span className={styles["nps-input__radio-decoration"]} />
            <span className={styles["nps-input__radio-label"]}>{label}</span>
        </label>
    );
};


